import type { JSX } from "react";
import { Stack } from "@genius-tracker/design-system";
import { useLocale } from "@genius-tracker/i18n/react";

import { TelegramHealthContent } from "../../../telegram/TelegramHealthPage.js";
import { useGtccHeadTabs } from "../control/HeadTabsContext.js";

/**
 * L-GTCC-36 — complete Telegram health in the GTCC mono-deck.
 *
 * The operational content is shared with gtcc1 so readiness posture, safe
 * configuration signals, delivery counters and the Owner-Go checklist cannot
 * drift. GtccShell owns the platform-owner gate around this view; the API keeps
 * its independent platform-owner guard on GET /v1/admin/telegram/health.
 */
export function GtccTelegramHealthView(): JSX.Element {
  const { t } = useLocale();
  const headTabs = useGtccHeadTabs();

  return (
    <Stack gap={4} style={{ padding: "var(--gt-sys-space-5)" }} data-testid="gtcc-view-tg">
      <Stack gap={1}>
        <h2 style={{ margin: 0, fontSize: "var(--gt-sys-font-size-lg)" }}>
          {t("admin.telegram.title")}
        </h2>
        <p style={{ margin: 0, color: "var(--gt-sys-text-muted)" }}>
          {t("admin.telegram.subtitle")}
        </p>
        <p
          style={{
            margin: 0,
            color: "var(--gt-sys-text-muted)",
            fontSize: "var(--gt-sys-font-size-xs)",
          }}
        >
          {t("admin.gtcc.ovw.read_only_note")}
        </p>
        <p
          style={{
            margin: 0,
            color: "var(--gt-sys-text-muted)",
            fontSize: "var(--gt-sys-font-size-xs)",
          }}
          data-testid="gtcc-tg-owner-go-note"
        >
          {t("admin.telegram.readiness_banner")}
        </p>
      </Stack>

      {headTabs}

      <TelegramHealthContent queryScope="gtcc" />
    </Stack>
  );
}
